import { Alert, TextOrHTML } from "@simplybusiness/mobius";
import type { QuestionComponentProps } from "../..";
import { QuestionLabel } from "../../../QuestionLabel";

export const InfoQuestion = ({
  questionFieldProps,
  config,
}: QuestionComponentProps) => {
  const { questionLabelProps } = questionFieldProps;
  const { primaryText, secondaryText } = questionLabelProps;
  const { level } = config ?? {};

  if (typeof level === "string") {
    return (
      <Alert header={primaryText} variant={level} show>
        {!!secondaryText && typeof secondaryText === "string" && (
          <TextOrHTML text={secondaryText} />
        )}
      </Alert>
    );
  }

  return <QuestionLabel {...questionLabelProps} />;
};
